import { getLocalUser, isSuperAdmin } from '../utils/authUser'

/**
 * 超级管理员判断混入：提供 isBlogAdmin / isSuperAdmin。
 * 若页面已有 currentUser，优先用页面数据；否则读 localStorage。创建于 2026-08-21
 */
export default {
  computed: {
    /** 是否为 admin / blogadmin（模板可用） */
    isBlogAdmin() {
      const user = this.currentUser != null ? this.currentUser : getLocalUser()
      return isSuperAdmin(user)
    },
    /** 与 isBlogAdmin 同义，语义更直观 */
    isSuperAdmin() {
      return this.isBlogAdmin
    }
  }
}
